<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户体力(用户当天首次登录体力)</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
          <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="100px"
        />
        <el-table-column
          v-for="(item, index) in spinLevelData"
          :key="index"
          :label="item"
          :formatter="numFormatter"
        >
          <template scope="{row}">
            {{ row.data[index].count }}
          </template>
        </el-table-column>

      </el-table>

      <el-row :gutter="12" class="mtop">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <UserSpinStat ref="stat" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <UserSpinStat ref="rate" :typ="2" />
        </el-col>
      </el-row>
    </el-card>

  </div>
</template>

<script>
import { exportStatData, getUserSpinStat } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'
import UserSpinStat from '@/views/config/user-spins/comments/user-spin-echart-stat.vue'

export default {
  name: 'UserSpin',
  components: {
    UserSpinStat
  },
  data() {
    return {
      loading: false,
      spinLevelData: [
        '0', '1-50', '51-100', '101-200', '201-500', '501-1000',
        '1001-2000', '2001-5000', '5001-10000', '10001+'],
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      }

    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery(select = true) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      if (select) {
        this.getTables()
      }
    },
    getTables() {
      this.loading = true
      getUserSpinStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          this.$refs.stat.refresh(this.spinLevelData, this.tableData)
          this.$refs.rate.refresh(this.spinLevelData, this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(typ) {
      let start = ''
      let end = ''
      this.handleQuery(false)
      start = this.queryParams.startDate
      end = this.queryParams.endDate

      if (start === '' || end === '') {
        return
      }
      this.loading = true
      exportStatData({ startDate: start, endDate: end, type: typ }).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
